<template>
  <div id="app">
    <navbar></navbar>
    <daily-index></daily-index>
    <sector-tables></sector-tables>
    <third-section></third-section>
    <fourth-table></fourth-table>
    <fifth-graph></fifth-graph>
    <Footer></Footer>
  </div>
</template>

<script>
import Navbar from './components/Navbar.vue'
import DailyIndex from './components/FirstSection/FirstSection.vue'
import SectorTables from './components/SecondSection/SecondSection.vue'
import ThirdSection from './components/ThirdSection/ThirdSection.vue'
import FourthTable from './components/FourthSection/FourthTable.vue'
import FifthGraph from './components/FifthSection/FifthSection.vue'
import Footer from './components/Footer.vue'
export default {
  name: 'App',
  components: {
    Navbar,
    DailyIndex,
    SectorTables,
    ThirdSection,
    FourthTable,
    FifthGraph,
    Footer
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  background: lightgrey;
}
</style>
